import ArrowDownIcon from "@pages/profile-v2/assets/icons/ArrowDownIcon.jsx";
import moment from "moment";
import React, { useEffect, useState } from "react";
import {
	BonusItemWrapper,
	ButtonText,
	CompletedBonusItemWrapper,
	CompletedInfoHeader,
	ContentInfo,
	Date,
	DateWrapper,
	Detail,
	DetailWrapper,
	DetailsButton,
	Info,
	InfoTitle,
	ItemContent,
	ItemHeader,
	WagerInfo,
} from "./elements";

const BonusItem = ({ data, index, translate, openIndex, setOpenIndex }) => {
	const bonusName = data.bonus.name;
	const amount = data.walletContributions[0].amount.value;
	const currency = data.walletContributions[0].amount.currency;
	const wagerPercentage = data.walletContributions[0].wageringRatio || 0;
	const startDate = moment.unix(data.bonus.creationDate).format("DD/MM/YYYY HH:mm");
	const endDate = moment
		.unix(data.bonus.creationDate)
		.add(data.bonus.triggerExpirationDays, "days")
		.format("DD/MM/YYYY HH:mm");
	const allowedTargets = Object.keys(data.bonus.limits).filter(
		(i) => data.bonus.limits[i].isAllowed
	);
	const areDetailsOpen = openIndex === index;
	const [windowWidth, setWindowWidth] = useState(window.innerWidth);

	useEffect(() => {
		const handleResize = () => setWindowWidth(window.innerWidth);
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	const shouldShowDetails = windowWidth >= 768 || areDetailsOpen;

	return (
		<CompletedBonusItemWrapper>
			<CompletedInfoHeader>{translate("BONUS_CONVERT_COMPLETED")}</CompletedInfoHeader>
			<BonusItemWrapper>
				<ItemHeader>{bonusName}</ItemHeader>
				<ItemContent>
					<ContentInfo>
						<InfoTitle>{translate("BONUS")}:</InfoTitle>
						<Info>
							{amount} {currency}
						</Info>
					</ContentInfo>
					<WagerInfo>{`%${parseFloat(wagerPercentage)}`}</WagerInfo>
				</ItemContent>
				{shouldShowDetails ? (
					<DetailWrapper>
						<Detail>{`Available in ${allowedTargets
							.map((i) => i.toUpperCase())
							.join(", ")}`}</Detail>
						<DateWrapper>
							<Date>
								{translate("Start")}: {startDate}
							</Date>
							<Date>
								{translate("Last")}: {endDate}
							</Date>
						</DateWrapper>
					</DetailWrapper>
				) : null}
				{windowWidth < 768 && (
					<DetailsButton
						rotate={areDetailsOpen}
						onClick={() => setOpenIndex(areDetailsOpen ? -1 : index)}>
						<ButtonText>
							{!areDetailsOpen ? translate("DETAILS") : translate("HIDE")}
						</ButtonText>
						<ArrowDownIcon />
					</DetailsButton>
				)}
			</BonusItemWrapper>
		</CompletedBonusItemWrapper>
	);
};

export default BonusItem;
